module.exports = __webpack_public_path__ + "img/quick-view.c77f92b.png";